import React from 'react';
import { Outlet } from 'react-router-dom';
import { TemuShopProvider } from '@/temu-platform/context/TemuShopContext';
import '@/styles/temu-platform/temu-platform.css';
import '@/styles/temu-platform/temu-product-ops.css';
import '@/styles/temu-platform/temu-notice-help.css';

/**
 * 通知帮助中心独立布局：无 TEMU 顶栏、无左侧菜单；内容铺满整页。
 */
export default function TemuStandaloneHelpLayout() {
  return (
    <TemuShopProvider>
      <div className="temu-help-standalone" data-testid="temu-standalone-help-layout">
        <Outlet />
      </div>
    </TemuShopProvider>
  );
}
